import dynamic from 'next/dynamic'
import { RadiusRingsIcon } from 'src/components/insights/icons/radius-rings'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import radiusRingsTradeAreaMapPreview from 'src/assets/images/widgets-previews/radius-rings-trade-area-map.png'
import radiusRingsTradeAreaOverviewPreview from 'src/assets/images/widgets-previews/radius-rings-trade-area-overview.png'
import radiusRingsTradeAreaConsumerSpendPreview from 'src/assets/images/widgets-previews/radius-rings-trade-area-consumer-spend.png'
import radiusRingsTradeAreaDemographicsPreview from 'src/assets/images/widgets-previews/radius-rings-trade-area-demographics.png'

const RadiusRingsTradeAreaMap = dynamic(() => import('src/components/insights/radius-rings-trade-area/map'), {
  ssr: false,
})

const RadiusRingsTradeAreaOverview = dynamic(() => import('src/components/insights/radius-rings-trade-area/overview'), {
  ssr: false,
})

const RadiusRingsTradeAreaConsumerSpend = dynamic(
  () => import('src/components/insights/radius-rings-trade-area/consumer'),
  {
    ssr: false,
  }
)

const RadiusRingsTradeAreaDemographics = dynamic(
  () => import('src/components/insights/radius-rings-trade-area/demographics'),
  {
    ssr: false,
  }
)

export const RadiusRingsTradeAreaMapWidget: InsightBuilderWidget = {
  id: 'radius-rings-trade-area-map',
  name: 'Radius Rings Map',
  type: 'Radius Rings Trade Area',
  icon: RadiusRingsIcon,
  component: RadiusRingsTradeAreaMap,
  supportedResultTypes: ['alphamap-location'],
  preview: radiusRingsTradeAreaMapPreview,
}

export const RadiusRingsTradeAreaOverviewWidget: InsightBuilderWidget = {
  id: 'radius-rings-trade-area-overview',
  name: 'Radius Rings Overview',
  type: 'Radius Rings Trade Area',
  icon: RadiusRingsIcon,
  component: RadiusRingsTradeAreaOverview,
  supportedResultTypes: ['alphamap-location'],
  preview: radiusRingsTradeAreaOverviewPreview,
}

export const RadiusRingsTradeAreaConsumerSpendWidget: InsightBuilderWidget = {
  id: 'radius-rings-trade-area-consumer-spend',
  name: 'Radius Rings Consumer Spend',
  type: 'Radius Rings Trade Area',
  icon: RadiusRingsIcon,
  component: RadiusRingsTradeAreaConsumerSpend,
  supportedResultTypes: ['alphamap-location'],
  preview: radiusRingsTradeAreaConsumerSpendPreview,
}

export const RadiusRingsTradeAreaDemographicsWidget: InsightBuilderWidget = {
  id: 'radius-rings-trade-area-demographics',
  name: 'Radius Rings Demographics',
  type: 'Radius Rings Trade Area',
  icon: RadiusRingsIcon,
  component: RadiusRingsTradeAreaDemographics,
  supportedResultTypes: ['alphamap-location'],
  preview: radiusRingsTradeAreaDemographicsPreview,
}
